// removed by extract-text-webpack-plugin
module.exports = {"adminTable":"AdminTable__adminTable___3oM-A","header":"AdminTable__header___1ncMB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/table/AdminTable.scss
// module id = 1595
// module chunks = 0